export default __webpack_public_path__ + "static/hw_ff_bme280_schem-30c728229ffa01058c1403d5bbd41743.png";